<wep-avatar-user [user]="params.value" [dimension]="30"
                 class="margin--center--vertical">
</wep-avatar-user>